<template>
  <div class="left">
    <img :src="img">
    <p style="margin-bottom:0">{{name}}</p>
    <p style="margin-top:0">余额：{{(balance/100).toFixed(2)}}</p>
    <ul class="list1">
        <li>
            <dt>剩余金币</dt>
            <dt>{{gold_coin}}个</dt>
        </li>
        <li>
            <dt>冻结金额</dt>
            <dt>{{(frozen_amount/100).toFixed(2)}}</dt>
        </li>
    </ul>
    <ul class="list2">
        <li :class="{active : (isActive==1)}" @click="nav('1')">
            <i class="iconfont icon-3"></i>
            充值(开发中)
        </li>
        <li :class="{active : (isActive==2)}">
            <i class="iconfont icon-tixian"></i>
            提现(开发中)
        </li>
        <li :class="{active : (isActive==3)}">
            <i class="iconfont icon-ai-eye"></i>
            认证中心(开发中)
        </li>
        <li :class="{active : (isActive==4)}">
            <i class="iconfont icon-xinxi"></i>
            账户详情(开发中)
        </li>
        <li :class="{active : (isActive==5)}">
            <i class="iconfont icon-V"></i>
            我的银行卡(开发中)
        </li>
        <li :class="{active : (isActive==6)}">
            <i class="iconfont icon-mima"></i>
            设置支付密码(开发中)
        </li>
        <li :class="{active : (isActive==7)}">
            <i class="iconfont icon-yijianfankui"></i>
            意见反馈(开发中)
        </li>
        <li :class="{active : (isActive==8)}">
            <i class="iconfont icon-shoucang"></i>
            我的关注(开发中)
        </li>
        <li :class="{active : (isActive==9)}" @click="loginout()">
            <i class="iconfont icon-tuichudenglu"></i>
            退出登录
        </li>
    </ul>
  </div>
</template>

<script>
export default {
  props:{
    isActive:{
        type:String,
        default:'1'
    }
  },
  data () {
    return {
        img:'',
        name:'',
        balance:0,
        gold_coin:0,
        frozen_amount:0,
    }
  },
  components:{

  },
  mounted(){
    var _this = this;
    this.$http.post(api.user_selectssinfo).then(function(res){
        if(res.data.code == 100001){
            _this.img = res.data.data[0].avatar;
            _this.name = res.data.data[0].mobile;
            _this.balance = res.data.data[0].balance;
            _this.frozen_amount = res.data.data[0].frozen_amount;
            _this.gold_coin = res.data.data[0].gold_coin;
        };      
    })
  },
  created(){
  },
  methods: {
    nav(){
        this.$emit('leftnav','1')
    },
    loginout(){
        var _this = this;
        this.$confirm('是否退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(api.user_loginOut).then(function(res){
            if(res.data.code == 100001){
              _this.$message({type: 'success',message: '退出成功!'});
              setTimeout(()=>{
                _this.$router.push('/')
              },1200)
                
            }else{
                _this.$message.error(res.data.message);
            };
          })
        }).catch(() => {
                   
        });
    }
  }
}



</script>

<style scoped >

.left{
    width:14.5%;
    height:100%;
    padding-top:50px;
    text-align:center;
    background: #f8fafc;
}
.left img{
    width:85px;
    height:85px;
    border-radius:50%;
}
.left p{
    margin: 2% 0 4.5%;
    font-size: 1.5rem;
}
.left .list1{
    overflow:hidden;
    margin:35px 0;
    border-bottom:1px solid #999999;
}
.left .list1 li{
    float:left;
    width: 50%;
}
.left .list1 li dt{
    font-size: 1.3rem;
    line-height: 40px;
}

.left .list2{
    overflow:hidden;
}
.left .list2 li{
    text-align:left;
    padding:0 14%;
    height: 50px;
    line-height: 50px;
}
.left .list2 li i{
    color:#999999
}
.left .list2 li:hover{
    background:#2fb8c2;
    color:#ffffff;
    cursor: pointer;
}
.left .list2 li.active{
    background:#2fb8c2;
    color:#ffffff;
}

</style>



// WEBPACK FOOTER //
// src/common/leftside.vue